import React, { Component } from 'react';
import { geoMercator, geoPath } from 'd3-geo';
import { feature } from 'topojson-client';
import './WorldMap.scss';

// https://medium.com/@zimrick/how-to-create-pure-react-svg-maps-with-topojson-and-d3-geo-e4a6b6848a98
class WorldMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            worldData: []
        };
    }

    projection() {
        return geoMercator()
            .scale(100)
            .translate([800 / 2, 450 / 2]);
    }

    componentDidMount() {
        fetch('/world-110m-sans-antarctica.json').then(response => {
            if (response.status !== 200) {
                // console.log(`There was a problem: ${response.status}`);
                // return
            }
            response.json().then(worldData => {
                this.setState({
                    worldData: feature(worldData, worldData.objects.countries)
                        .features
                });
            });
        });
    }

    render() {
        return (
            <svg width={'100%'} height={'100%'} viewBox="0 0 800 350">
                <g className="countries">
                    {this.state.worldData.map((d, i) => (
                        <path
                            key={`path-${i}`}
                            d={geoPath().projection(this.projection())(d)}
                            className="country"
                            // fill={ `rgba(38,50,56,${1 / this.state.worldData.length * i})` }
                            fill={`var(--dark-gray)`}
                            stroke="#FFFFFF"
                            strokeWidth={0.5}
                        />
                    ))}
                </g>
                <g className="markers">
                    {this.props.countriesData.map((country, i) => {
                        return (
                            <g
                                key={`marker-${i}`}
                                onClick={() =>
                                    this.props.handleMarkerClick(
                                        country.countryCode
                                    )
                                }
                            >
                                <circle
                                    key={`outer-${i}`}
                                    cx={
                                        this.projection()([
                                            country.coordinates.lon,
                                            country.coordinates.lat
                                        ])[0]
                                    }
                                    cy={
                                        this.projection()([
                                            country.coordinates.lon,
                                            country.coordinates.lat
                                        ])[1]
                                    }
                                    r={23}
                                    fill="rgba(123, 130, 147, 0.4)"
                                    className="marker"
                                    // onClick={() => this.props.handleMarkerClick(i)}
                                    visibility={
                                        this.props.chosenCountry ===
                                        country.countryCode
                                            ? 'visible'
                                            : 'hidden'
                                    }
                                />
                                <circle
                                    key={`third-${i}`}
                                    cx={
                                        this.projection()([
                                            country.coordinates.lon,
                                            country.coordinates.lat
                                        ])[0]
                                    }
                                    cy={
                                        this.projection()([
                                            country.coordinates.lon,
                                            country.coordinates.lat
                                        ])[1]
                                    }
                                    r={13}
                                    fill="#FFFFFF"
                                    className="marker"
                                    // onClick={() => this.props.handleMarkerClick(i)}
                                />
                                <circle
                                    key={`second-${i}`}
                                    cx={
                                        this.projection()([
                                            country.coordinates.lon,
                                            country.coordinates.lat
                                        ])[0]
                                    }
                                    cy={
                                        this.projection()([
                                            country.coordinates.lon,
                                            country.coordinates.lat
                                        ])[1]
                                    }
                                    r={7}
                                    fill="var(--darker-gray)"
                                    className="marker"
                                    // onClick={() => this.props.handleMarkerClick(i)}
                                />
                                <circle
                                    key={`first-${i}`}
                                    cx={
                                        this.projection()([
                                            country.coordinates.lon,
                                            country.coordinates.lat
                                        ])[0]
                                    }
                                    cy={
                                        this.projection()([
                                            country.coordinates.lon,
                                            country.coordinates.lat
                                        ])[1]
                                    }
                                    r={2}
                                    fill="var(--blue)"
                                    className="marker"
                                    id="outer-{i}"
                                    // onClick={() => this.props.handleMarkerClick(i)}
                                />
                            </g>
                        );
                    })}
                </g>
            </svg>
        );
    }
}

export default WorldMap;

// Note: [Markers] 4 circles
// 1st circle shown only if any of the other 3 was clicked. ... note this circle might not be fixed size for all ... need to use 2nd circle data to set this.
// 2nd circle is just a white background
// 3rd circle shows the traffic .. needs to be calculated
// 4th circle shows the number of alerts ... needs to be calculated.
